var Handlebars = require("/Users/niall/projects/workflows-js/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"form-group\">\n    <hr class=\"double-hr\">\n\n    <div class=\"form-check\">\n        <input class=\"required form-check-input\" type=\"checkbox\" id=\"required\">\n        <label class=\"form-check-label\" for=\"required\">\n            Required?\n        </label>\n    </div>\n\n    <textarea class=\"form-control required-description\" rows=\"3\"\n              placeholder=\"Requirements clarification\"></textarea>\n    <small class=\"form-text text-muted\">Required node has solid arrows.</small>\n</div>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/templates/edit_mode/_required.hbs
// module id = 137
// module chunks = 0